import type { ChangeEvent, ReactNode } from 'react';

interface CampoBaseProps {
  rotulo: string;
  dica?: string;
  largo?: boolean;
  obrigatorio?: boolean;
}

export function BlocoCampos({ titulo, descricao, children, acoes }: {
  titulo: string;
  descricao?: string;
  children: ReactNode;
  acoes?: ReactNode;
}) {
  return (
    <section className="manual-bloco">
      <header className="manual-bloco-cabecalho">
        <div>
          <h2>{titulo}</h2>
          {descricao && <p>{descricao}</p>}
        </div>
        {acoes && <div className="manual-bloco-acoes">{acoes}</div>}
      </header>
      <div className="manual-bloco-corpo">{children}</div>
    </section>
  );
}

export function CampoTexto({ rotulo, dica, largo, obrigatorio, valor, tipo = 'text', placeholder, aoMudar }: CampoBaseProps & {
  valor: string;
  tipo?: 'text' | 'date' | 'number';
  placeholder?: string;
  aoMudar: (valor: string) => void;
}) {
  return (
    <label className={`manual-field ${largo ? 'is-wide' : ''}`}>
      <span className="manual-field-topo">{rotulo}{obrigatorio && <em>Obrigatório</em>}</span>
      <input
        type={tipo}
        value={valor}
        placeholder={placeholder}
        onChange={(evento: ChangeEvent<HTMLInputElement>) => aoMudar(evento.target.value)}
      />
      {dica && <small>{dica}</small>}
    </label>
  );
}

export function CampoArea({ rotulo, dica, largo = true, obrigatorio, valor, linhas = 4, placeholder, aoMudar }: CampoBaseProps & {
  valor: string;
  linhas?: number;
  placeholder?: string;
  aoMudar: (valor: string) => void;
}) {
  return (
    <label className={`manual-field ${largo ? 'is-wide' : ''}`}>
      <span className="manual-field-topo">{rotulo}{obrigatorio && <em>Obrigatório</em>}</span>
      <textarea
        rows={linhas}
        value={valor}
        placeholder={placeholder}
        onChange={(evento: ChangeEvent<HTMLTextAreaElement>) => aoMudar(evento.target.value)}
      />
      {dica && <small>{dica}</small>}
    </label>
  );
}

export function CampoSelecao({ rotulo, dica, largo, valor, opcoes, aoMudar }: CampoBaseProps & {
  valor: string;
  opcoes: { valor: string; rotulo: string }[];
  aoMudar: (valor: string) => void;
}) {
  return (
    <label className={`manual-field ${largo ? 'is-wide' : ''}`}>
      <span className="manual-field-topo">{rotulo}</span>
      <select value={valor} onChange={(evento) => aoMudar(evento.target.value)}>
        {opcoes.map((opcao) => (
          <option key={opcao.valor} value={opcao.valor}>{opcao.rotulo}</option>
        ))}
      </select>
      {dica && <small>{dica}</small>}
    </label>
  );
}

export function Interruptor({ rotulo, descricao, ativo, aoMudar }: {
  rotulo: string;
  descricao?: string;
  ativo: boolean;
  aoMudar: (ativo: boolean) => void;
}) {
  return (
    <button
      type="button"
      className={`manual-switch ${ativo ? 'is-on' : ''}`}
      onClick={() => aoMudar(!ativo)}
      aria-pressed={ativo}
    >
      <span className="manual-switch-track"><i /></span>
      <span className="manual-switch-label">
        <strong>{rotulo}</strong>
        {descricao && <small>{descricao}</small>}
      </span>
    </button>
  );
}

export function Sugestoes({ titulo = 'Sugestões', itens, aoEscolher }: {
  titulo?: string;
  itens: string[];
  aoEscolher: (valor: string) => void;
}) {
  if (!itens.length) return null;
  return (
    <div className="manual-sugestoes">
      <span>{titulo}</span>
      <div>
        {itens.map((item) => (
          <button key={item} type="button" onClick={() => aoEscolher(item)}>{item}</button>
        ))}
      </div>
    </div>
  );
}

export function Grade({ children }: { children: ReactNode }) {
  return <div className="manual-field-grid">{children}</div>;
}
